
const personalityAttributes = {
    number: "1/1",
    question: "Attribute Scale",
    description: `Bring attributes that were contradictory from the previous two steps, and put them in a scale. By finding the
                                                    balance between them we also create a brand personality that we can quickly describe, and use across our messaging. E.g. If you used the adjective "Energetic" in Look and Feel, and then "Serious" in Look and Feel or Tone of Voice, the two adjectives seem to be fighting each other. Bring these together and rate which one should weigh more.`
}

export const questions = {
    personalityAttributes: personalityAttributes,
}

const personalityAttributesVideo = {
    url: "https://www.dropbox.com/scl/fi/4yjhg2o28czbcv29i98nf/27-Brand-attributes.mp4?rlkey=unc20piq74kpny131q1mk5ecu&raw=1"
}

export const videos = {
    personalityAttributesVideo: personalityAttributesVideo,
}